const REFERRAL_STORAGE_KEY = 'seller_ref';
const REFERRAL_COOKIE_KEY = 'referral';
const REFERRAL_TTL_SECONDS = 7 * 24 * 60 * 60;

const normalizeReferral = (value) => {
  const code = String(value || '').trim().toUpperCase();
  return /^[A-Z0-9]{1,32}$/.test(code) ? code : '';
};

const referralFromUrl = (url) => {
  if (!url) return '';

  try {
    const parsed = new URL(url, window.location.origin);
    const queryCode = parsed.searchParams.get('vendedor') || parsed.searchParams.get('ref');
    if (queryCode) return normalizeReferral(queryCode);

    const hash = parsed.hash.replace(/^#/, '');
    const hashParams = new URLSearchParams(hash.includes('?') ? hash.split('?').pop() : hash);
    return normalizeReferral(hashParams.get('vendedor') || hashParams.get('ref'));
  } catch (error) {
    return '';
  }
};

const readReferralCookie = () => {
  if (typeof document === 'undefined') return '';
  const cookie = document.cookie.split('; ').find((entry) => entry.startsWith(`${REFERRAL_COOKIE_KEY}=`));
  return normalizeReferral(cookie ? decodeURIComponent(cookie.slice(REFERRAL_COOKIE_KEY.length + 1)) : '');
};

const readStoredReferral = () => {
  if (typeof window === 'undefined') return '';
  try {
    return normalizeReferral(window.localStorage.getItem(REFERRAL_STORAGE_KEY)) || readReferralCookie();
  } catch (error) {
    return readReferralCookie();
  }
};

const persistReferral = (code) => {
  if (!code || typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(REFERRAL_STORAGE_KEY, code);
  } catch (error) {
    // La cookie conserva el referido si el navegador bloquea localStorage.
  }

  if (typeof document !== 'undefined') {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${REFERRAL_COOKIE_KEY}=${encodeURIComponent(code)}; Path=/; SameSite=Lax; Max-Age=${REFERRAL_TTL_SECONDS}${secure}`;
  }
};

export const captureSellerReferral = () => {
  if (typeof window === 'undefined') return '';

  const currentCode = referralFromUrl(window.location.href);
  const referrerCode = referralFromUrl(document.referrer);
  const code = currentCode || referrerCode || readStoredReferral();
  persistReferral(code);
  return code;
};

export const getSellerReferral = () => readStoredReferral();
